import { styled, css } from '@mui/material/styles';
import {
  Box,
  Button as Btn,
  IconButton,
  TableContainer,
  TableCell as TableCellStyles,
  Table as TableStyles,
  Typography,
  Button,
} from '@mui/material';

import { Input as InputComponent } from '../../../components/Input';

interface ButtonProps {
  isActived: boolean;
}

export const HeaderCreate = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 10px 10px 10px;
  padding: 0px 0px 16px;
  border-bottom: 1px solid #bdbdbd;
  margin-bottom: 20px;
`;

export const TitleBox = styled(Box)`
  margin-left: 38%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
    margin-bottom: 15px;
  }

  .Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #ff9800 !important;
  }
`;

export const Header = styled(Box)`
  height: 58px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12);

  .btn-back {
    width: 125px;
    height: 42px;
    margin: 10px 0 10px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
`;

export const Page = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 0px 20px 20px 20px;
`;

export const SubHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 0px 20px 5px 20px;
  height: 48px;

  .members {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;
    width: 160px;
    height: 48px;
    /* White */
    background: ${({ theme }) => theme.palette.common.white};
  }
  .groups {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;
    width: 160px;
    height: 48px;
    /* White */
    background: ${({ theme }) => theme.palette.common.white};
  }
`;

export const Content = styled(Box)`
  .section-recurrence {
    padding: 20px;
  }
  .header-guests {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 25px 8px 20px 25px;
    align-items: center;
  }

  .btn-save-guest {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    width: 70px;
    height: 36px;
    /* background: rgba(0, 0, 0, 0.12); */
    border-radius: 4px;
  }
  .input-container {
    height: 42px;
    margin: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .name-filter {
    width: 100%;
    height: 42px;
    border: 1px solid #4c4c4c;
    border-radius: 5px;
    padding: 8px 50px;
    opacity: 0.5;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */
    display: flex;
    align-items: center;
    /* Grey/Off Black */
    color: #0e0e2c;
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;

    .title {
      font-weight: 400;
      font-size: 24px;
      color: #303030;
    }

    .label {
      font-weight: 500;
      font-size: 16px;
      color: #303030;
      margin: 20px 0;
    }
  }
  /* .css-1b6yrrg {
    width: fit-content;
  } */
`;

export const Section = styled(Box)`
  height: 100%;
  &.disabled {
    background-color: ${({ theme }) => theme.palette.grey[400]};
    cursor: not-allowed;

    button {
      border-radius: 32px;
      height: 24px;
      color: ${({ theme }) => theme.palette.common.white};
      text-transform: capitalize;
      background-color: ${({ theme }) => theme.palette.grey.A100};
    }
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    ul {
      padding: 0;
    }

    li {
      list-style: none;
    }
  }

  .content-guests {
    padding: 5px 20px 0px 20px;
  }

  .meeting-details {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    margin-bottom: 20px;
  }

  .buttons {
    display: flex;
    gap: 20px;
  }

  .btn-cancel {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 32px;
    width: 64px;
    height: 24px;
    text-transform: capitalize;
  }

  .btn-save {
    background: #4caf50;
    border-radius: 32px;
    width: 151px;
    height: 24px;
    color: ${({ theme }) => theme.palette.common.white};
    text-transform: capitalize;
  }

  h4 {
    margin: 5px 0 5px 0;
    padding: 0;
  }

  .input-date {
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .inputs {
    width: 100%;
  }

  .initial-input {
    width: 90%;
    ::-webkit-datetime-local-edit-year-field:not([aria-valuenow]),
    ::-webkit-datetime-local-edit-month-field:not([aria-valuenow]),
    ::-webkit-datetime-local-edit-day-field:not([aria-valuenow]) {
      color: transparent;
    }
  }

  .btn-repetition {
    /* width: 134px; */
    display: flex;
    align-items: center;
    gap: 10px;
    text-transform: none;
    height: 44px;
    margin-top: 10px;
    margin-bottom: 30px;
    color: #0b79d0;
    padding: 0;

    :hover {
      background-color: #fff;
    }
  }

  .date {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .checkbox {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    margin-top: 10px;
    gap: 11px;
  }

  .link {
    margin-top: 10px;
  }

  .section-conference {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .menu-left {
    display: flex;
    flex-direction: column;
  }

  .btn-conference {
    height: 26px;
    border-radius: 32px;
    text-transform: capitalize;
  }

  .section-guests {
    display: flex;
    flex-direction: column;
  }

  .box-items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .title-conference {
    margin: 0;
  }

  .btn-edit {
    background-color: #206da7;
    color: ${({ theme }) => theme.palette.common.white};
    text-transform: capitalize;
  }

  .btn-rounded {
    border-radius: 32px;
    height: 26px;
  }
  .datetime-input {
    width: 100%;
  }
`;

export const Input = styled(InputComponent)``;

export const Guests = styled(Box)`
  display: flex;
  flex-direction: row;

  .arrow-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .guests {
    display: flex;
    flex-direction: row;
    list-style: none;
    gap: 25px;
    padding: 0;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .guest {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
  }

  p {
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

export const ButtonGuestsClose = styled(IconButton)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  background-color: #d9d9d9;
  cursor: pointer;
  height: 40px !important;
  width: 40px !important;
  border-radius: 20px;

  &:hover {
    filter: brightness(0.9);
  }

  &.disabled {
    background-color: ${({ theme }) => theme.palette.grey[400]};
    cursor: not-allowed;

    button {
      color: ${({ theme }) => theme.palette.common.white};
      background-color: ${({ theme }) => theme.palette.grey.A100};
    }
  }
`;

export const Div = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;

  .input-date {
    background-color: #4c4c4c;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 2px solid #fdfdfd;
    width: 180px;
    height: 24px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #fdfdfd;
  }

  .select-date {
    color: #fdfdfd;
    width: 220px;
  }
  .icon {
    color: #fdfdfd;
  }

  .title {
    height: 40px;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .title-modal {
    font-size: 18px;
    margin: 0;
  }

  .align-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
  }

  .align {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 35px;
    margin-left: 5px;
  }

  .css-3mvg2v-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {
    border-bottom: 2px solid rgb(255 255 255);
  }

  .css-jj8kbs-MuiSvgIcon-root-MuiSelect-icon {
    color: rgba(255 255 255);
  }

  .btn-add-data {
    width: auto;
    height: 32px;
    display: flex;
    align-items: center;
    gap: 5px;
    color: #ffffff;
  }
`;

export const Article = styled(Box)`
  .weekend {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 0;
    margin: 10px 0px 0px 0px;
    margin: 15px 0px 0px 0px;
  }
  .title-article {
    color: black;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
  }

  .input-date-article {
    background-color: #4c4c4c;
    border: 0;

    height: 24px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #fdfdfd;
  }

  .btn-remove-date {
    margin-left: 12px;
    color: #fdfdfd;
    text-transform: initial;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
  }

  .btn-descart {
    width: 132px;
    height: 42px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    background: #fafafa;
    border: 1px solid #e31b0c;
    border-radius: 4px;
    color: #e31b0c;
  }

  .btn-save {
    width: 101px;
    height: 42px;
    background-color: #206da7;
    color: ${({ theme }) => theme.palette.common.white};
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
  }

  .align-btn {
    display: flex;
    flex-direction: row;
    gap: 20px;
    bottom: 0;
    margin-top: 73px;
  }
  li {
    list-style: none;
  }

  .align-remove-date {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
interface DayProps {
  active: boolean;
}

export const ButtonDay = styled(Btn)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  list-style: none;
  width: 16px;
  height: 26px;
  background-color: #61616114;
  color: #4c4c4c;
  border-radius: 50%;
  box-shadow: none;
  min-width: 16px;
  ${(props: DayProps) =>
    props.active &&
    css`
      background-color: #3498db;
      color: #ffffff;
    `}
`;
interface TabSelected {
  active: boolean;
}

export const ButtonMembers = styled(Btn)`
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  ${(props: TabSelected) =>
    props.active &&
    css`
      color: #206da7;
      border-bottom: 2px solid #206da7;
    `}
`;

export const Title = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 25px;
  p {
    font-style: normal;
    font-weight: 500;

    line-height: 22px;
  }
`;

export const RecurrenceCard = styled(Box)`
  width: 100%;
  background: #eeeeee;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  margin-bottom: 10px;
  justify-content: space-between;

  svg {
    width: 22px;
    color: #616161;
  }
`;

export const RecurrenceCardText = styled(Typography)`
  color: ${({ theme }) => theme.palette.grey[800]};
  font-weight: 400;
  font-size: 16px;
`;

export const SectionMeeting = styled(Box)`
  border: 2px solid ${({ theme }) => theme.palette.primary.dark};
  border-radius: 6px;
  height: 103px;
  margin: 20px 25px 20px 25px;
  padding-left: 30px;
  padding-right: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.light};
  }

  .menu-left {
    display: flex;
    flex-direction: row;
  }

  .menu-right {
    .edit {
      .drawer {
        /* background-color: red; */
      }
    }
  }

  .container-section {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .name-section {
    display: flex;
    flex-direction: column;
  }

  .btn-pauta {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1px 9px;
    font-size: 14px;
    width: 158px;
    height: 21px;
    background: ${({ theme }) => theme.palette.primary.main};
    border-radius: 17px;

    text-transform: none;
    white-space: nowrap;
  }

  p {
    padding: 0;
    margin: 0;
  }

  .name {
    font-weight: 500;
    font-size: 20px;
    line-height: 160%;
    letter-spacing: 0.15px;
    margin-left: 10px;
  }

  .number {
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
  }

  .align {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
  }

  .css-1xkvp8t-MuiSvgIcon-root {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 30.33px;
    height: 31.33px;
    display: inline-block;
    fill: currentColor;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    font-size: 1.3928571428571428rem;
  }
`;

export const TableContainerStyles = styled(TableContainer)`
  margin-top: 18px;
  background: #ffffff;
  box-shadow: 0px 3px 5px -2px rgba(0, 0, 0, 0.2),
    0px 2px 3px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  .css-1moeq7m-MuiTableHead-root {
    background-color: #fff;
  }
  .css-1moeq7m-MuiTableHead-root
    .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root {
    color: black;
  }
  .css-1moeq7m-MuiTableHead-root
    .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active {
    color: black;
  }
`;

export const ListDates = styled(Box)``;

export const TableCell = styled(TableCellStyles)`
  font-size: 14px;
`;

export const Table = styled(TableStyles)`
  .css-1xkvp8t-MuiSvgIcon-root {
    width: 0;
  }

  .css-hw22yz-MuiTableCell-root {
    font-size: 16px;
  }
`;

export const DatesAutomatic = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 15px;
  gap: 10px;
  width: 440px;
  height: 36px;
  background: #eeeeee;
  border-radius: 6px;
`;

export const HeaderDates = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #323232;
`;

export const CheckButtons = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

export const ButtonExternal = styled(Button)`
  border-radius: 4px;
  border: 1px solid #cdcdcd;
  display: flex;
  height: 45px;
  padding: 4px 15px;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-family: Roboto;
  line-height: 20px;
  letter-spacing: 0.15px;
  text-transform: none;
  font-weight: 300;
  color: #212b36;

  ${(props: ButtonProps) =>
    props.isActived &&
    css`
      background-color: #cdcdcd54;
    `}
`;

export const ButtonZoom = styled(Button)`
  border-radius: 4px;
  border: 1px solid #cdcdcd;
  display: flex;
  height: 45px;
  padding: 4px 15px;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-family: Roboto;
  line-height: 20px;
  letter-spacing: 0.15px;
  text-transform: none;
  font-weight: 300;
  color: #212b36;

  ${(props: ButtonProps) =>
    props.isActived &&
    css`
      background-color: #cdcdcd54;
    `}
`;

export const ButtonTeams = styled(Button)`
  border-radius: 4px;
  border: 1px solid #cdcdcd;
  display: flex;
  height: 45px;
  padding: 4px 15px;
  align-items: center;
  gap: 10px;

  font-size: 14px;
  font-family: Roboto;
  line-height: 20px;
  letter-spacing: 0.15px;
  text-transform: none;
  font-weight: 300;
  color: #212b36;

  ${(props: ButtonProps) =>
    props.isActived &&
    css`
      background-color: #cdcdcd54;
    `}
`;

export const VideoconferenceTitle = styled(Typography)`
  color: #000;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.15px;
`;

export const DateConfigure = styled(Box)`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

export const DateConfigureTitle = styled(Typography)`
  color: #000;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.15px;

  display: flex;
  align-items: center;
  gap: 10px;
`;

export const NumberOfMeeting = styled(Typography)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 40px;

  font-size: 16px;
  font-family: Roboto;
  line-height: 24px;
  letter-spacing: 0.15px;
  font-weight: 300;
`;

export const SuccessOAuth = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const TextZoom = styled(Box)`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.15px;
`;
